var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["gift_product_code"] } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_code"]
                            },
                            model: {
                              value: _vm.queryParam.code,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "code", $$v)
                              },
                              expression: "queryParam.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["gift_product_name"] } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_name"]
                            },
                            model: {
                              value: _vm.queryParam.name,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "name", $$v)
                              },
                              expression: "queryParam.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_app"],
                            labelCol: _vm.labelCol
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language["gift_user_app"],
                              options: _vm.appList,
                              disabled: _vm.appLimit.flag
                            },
                            on: { change: _vm.handlerApp },
                            model: {
                              value: _vm.queryParam.app,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "app", $$v)
                              },
                              expression: "queryParam.app"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "produc:supplier",
                          expression: "'produc:supplier'"
                        }
                      ],
                      attrs: { xl: 6, lg: 7, md: 8, sm: 24 }
                    },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.language["gift_product_vendor"] }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["gift_product_vendor"]
                              },
                              on: { change: _vm.updateSupplier },
                              model: {
                                value: _vm.queryParam.supplier,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParam, "supplier", $$v)
                                },
                                expression: "queryParam.supplier"
                              }
                            },
                            _vm._l(_vm.vendorMap, function(v, k) {
                              return _c(
                                "a-select-option",
                                { key: k, attrs: { value: k, label: v } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(v) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.toggleSearchStatus
                    ? [
                        _c(
                          "a-col",
                          {
                            directives: [
                              {
                                name: "has",
                                rawName: "v-has",
                                value: "produc:supplier",
                                expression: "'produc:supplier'"
                              }
                            ],
                            attrs: { xl: 6, lg: 7, md: 8, sm: 24 }
                          },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label: _vm.language["gift_merchant_name"]
                                }
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder:
                                        _vm.language["common.pleaseChoose"] +
                                        _vm.language["gift_merchant_name"]
                                    },
                                    on: { change: _vm.updateBusiness },
                                    model: {
                                      value: _vm.queryParam.businessName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "businessName",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.businessName"
                                    }
                                  },
                                  _vm._l(_vm.businessMap, function(v, k) {
                                    return _c(
                                      "a-select-option",
                                      { key: k, attrs: { value: k, label: v } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(v) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: _vm.language["gift_up_down"],
                                  labelCol: _vm.labelCol
                                }
                              },
                              [
                                _c("j-dict-select-tag", {
                                  attrs: {
                                    type: "list",
                                    dictCode: "gift_up_down",
                                    disabled: _vm.formDisabled
                                  },
                                  model: {
                                    value: _vm.queryParam.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "status", $$v)
                                    },
                                    expression: "queryParam.status"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: { click: _vm.handleToggleSearch }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.toggleSearchStatus
                                    ? _vm.language["common.foldButton"]
                                    : _vm.language["common.unfoldButton"]
                                ) +
                                "\n              "
                            ),
                            _c("a-icon", {
                              attrs: {
                                type: _vm.toggleSearchStatus ? "up" : "down"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "product:add",
                  expression: "'product:add'"
                }
              ],
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v(_vm._s(_vm.language["common.insertButton"]))]
          ),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "product:export",
                  expression: "'product:export'"
                }
              ],
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.handleExportXls("商品管理列表")
                }
              }
            },
            [_vm._v(_vm._s(_vm.language["common.exportButton"]))]
          ),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "product:import",
                  expression: "'product:import'"
                }
              ],
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.downloadTemplate()
                }
              }
            },
            [_vm._v(_vm._s(_vm.language["common.import.template.download"]))]
          ),
          _c(
            "a-upload",
            {
              attrs: {
                name: "file",
                showUploadList: false,
                multiple: false,
                headers: _vm.tokenHeader,
                action: _vm.importExcelUrl
              },
              on: { change: _vm.handleImportExcel }
            },
            [
              _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "has",
                      rawName: "v-has",
                      value: "product:import",
                      expression: "'product:import'"
                    }
                  ],
                  attrs: { type: "primary", icon: "import" }
                },
                [_vm._v(_vm._s(_vm.language["common.importButton"]))]
              )
            ],
            1
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "eye" },
              on: { click: _vm.handlePreviewProductList }
            },
            [_vm._v(_vm._s(_vm.language["common.preview"]))]
          ),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _vm.isHideDele
                        ? _c(
                            "a-menu-item",
                            { key: "1", on: { click: _vm.batchDel } },
                            [
                              _c("a-icon", { attrs: { type: "delete" } }),
                              _vm._v(
                                _vm._s(_vm.language["common.delete"]) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-menu-item",
                        {
                          key: "2",
                          on: {
                            click: function($event) {
                              return _vm.handleUpOrDown(1)
                            }
                          }
                        },
                        [
                          _c("a-icon", { attrs: { type: "up" } }),
                          _vm._v("上架\n        ")
                        ],
                        1
                      ),
                      _c(
                        "a-menu-item",
                        {
                          key: "2",
                          on: {
                            click: function($event) {
                              return _vm.handleUpOrDown(0)
                            }
                          }
                        },
                        [
                          _c("a-icon", { attrs: { type: "down" } }),
                          _vm._v("下架\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "product:delete",
                          expression: "'product:delete'"
                        }
                      ],
                      staticStyle: { "margin-left": "8px" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.language["common.batchAction"]) +
                          "\n        "
                      ),
                      _c("a-icon", { attrs: { type: "down" } })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon"
              }),
              _vm._v(" " + _vm._s(_vm.language["common.choosed"]) + " "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length))
              ]),
              _vm._v(_vm._s(_vm.language["common.item"]) + "\n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected }
                },
                [_vm._v(_vm._s(_vm.language["common.clear"]))]
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: true },
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: false,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange
              }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "imgSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无图片")]
                        )
                      : _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic",
                            cursor: "pointer"
                          },
                          attrs: {
                            src: _vm.getImgViewCode(text, _vm.applicationCode),
                            height: "25px",
                            width: "50px",
                            alt: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.imgView(
                                _vm.getImgViewCode(text, _vm.applicationCode)
                              )
                            }
                          }
                        }),
                    _c(
                      "a-modal",
                      {
                        attrs: {
                          mask: false,
                          width: 1000,
                          title: _vm.language["gift_product_thumbnail"],
                          visible: _vm.previewVisible,
                          "confirm-loading": false,
                          "ok-button-props": { props: { disabled: true } },
                          cancelText: _vm.language["common.closeButton"]
                        },
                        on: { cancel: _vm.handleCancel }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "100%" },
                          attrs: { alt: "example", src: _vm.previewImage }
                        })
                      ]
                    )
                  ]
                }
              },
              {
                key: "switchSlot",
                fn: function(status, record, idx) {
                  return _c(
                    "span",
                    {},
                    [
                      _c("a-switch", {
                        attrs: { checked: status },
                        on: {
                          click: function($event) {
                            return _vm.changeStatus(status, record, idx)
                          }
                        }
                      })
                    ],
                    1
                  )
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a-button",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "product:edit",
                              expression: "'product:edit'"
                            }
                          ],
                          attrs: {
                            type: "link",
                            disabled: record.activeStatus === 2
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.language["common.edit"]))]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "product:copy",
                              expression: "'product:copy'"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.handleCopy(record)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.language["epi.copy"]))]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v(
                                _vm._s(_vm.language["common.more"]) +
                                  "\n            "
                              ),
                              _c("a-icon", { attrs: { type: "down" } })
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDetail(record)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.language["common.detailsButton"]
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handlePreviewProduct(record)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.language["common.preview"])
                                    )
                                  ]
                                )
                              ]),
                              record.status === 0 && record.activeStatus === 0
                                ? _c(
                                    "a-menu-item",
                                    {
                                      directives: [
                                        {
                                          name: "has",
                                          rawName: "v-has",
                                          value: "product:delete",
                                          expression: "'product:delete'"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "a-popconfirm",
                                        {
                                          attrs: {
                                            title:
                                              _vm.language[
                                                "common.deleteConfirmInfo"
                                              ]
                                          },
                                          on: {
                                            confirm: function() {
                                              return _vm.handleDelete(record)
                                            }
                                          }
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.language["common.delete"]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("gift-product-info-modal", {
        ref: "modalForm",
        attrs: { vendorList: _vm.vendorList, appList: _vm.appList },
        on: { ok: _vm.modalFormOk }
      }),
      _c("preview-product-modal", {
        attrs: {
          visible: _vm.previewProduct,
          "record-data": _vm.previewRecord,
          "product-id": _vm.previewRecord.id,
          "tags-data": _vm.tags
        },
        on: { close: _vm.closePreviewProduct }
      }),
      _c("preview-product-list-modal", {
        attrs: { visible: _vm.previewProductList, record: _vm.dataSource },
        on: { close: _vm.closePreviewProductList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }